/* eslint-disable indent */
import type { REPORT_RANGE } from '@consts/reports';
import { parseDate } from './dates';

export const sortRecordAsc =
    <T>(key: keyof T) =>
    (a: T, b: T) => {
        switch (typeof a[key]) {
            case 'string': {
                const A = (a[key] as string)?.toLowerCase() || '~';
                const B = (b[key] as string)?.toLowerCase() || '~';
                const value = A < B ? -1 : A > B ? 1 : 0;
                return value;
            }
            case 'number': {
                const value = (a[key] as number) - (b[key] as number);
                return value;
            }
            case 'undefined': {
                return -1;
            }
            default:
                throw new Error(`Type ${typeof a[key]} for ${key.toString()} is not supported for sortRecord`);
        }
    };

export const sortRecordDesc =
    <T>(key: keyof T) =>
    (a: T, b: T) => {
        switch (typeof a[key]) {
            case 'string': {
                const A = (a[key] as string)?.toLowerCase() || '~';
                const B = (b[key] as string)?.toLowerCase() || '~';
                const value = A > B ? -1 : A < B ? 1 : 0;
                return value;
            }
            case 'number': {
                const value = (b[key] as number) - (a[key] as number);
                return value;
            }
            case 'undefined': {
                return -1;
            }
            default:
                throw new Error(`Type ${typeof a[key]} for ${key.toString()} is not supported for sortRecord`);
        }
    };

export const basicSort = (itemA: string | number, itemB: string | number, direction: string) => {
    const ascending = direction === 'ascending';

    if (ascending && itemA > itemB) {
        return -1;
    } else if (ascending && itemA < itemB) {
        return 1;
    }

    if (!ascending && itemA < itemB) {
        return -1;
    } else if (!ascending && itemA > itemB) {
        return 1;
    }

    return 0;
};

export const dateSort =
    (format: REPORT_RANGE) => (itemA: string | number, itemB: string | number, direction: string) => {
        const ascending = direction === 'ascending';

        const itemAString = typeof itemA === 'string';
        const itemBString = typeof itemB === 'string';

        const itemADate = itemAString ? parseDate(itemA, format).unix() : itemA;
        const itemBDate = itemBString ? parseDate(itemB, format).unix() : itemB;

        if (ascending) {
            return itemBDate - itemADate;
        } else {
            return itemADate - itemBDate;
        }
    };
